import { postRequest } from '../apiRequest'

interface Props {
  formData: FormData
}

export const changeAvatar = ({ formData }: Props) => postRequest('/users/avatar', formData)
